import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.incident-aktualisieren';
import * as api from '../../../clients/incidents';

@Injectable()
export class IncidentsIncidentAktualisierenEffects {

    IncidentAktualisieren$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_INCIDENT_AKTUALISIEREN),
        mergeMap((x: ac.PostIncidentAktualisierenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postIncidentAktualisieren(x.incidentAktualisierenRequest).pipe(
                map((result: any) => {
                    return new ac.PostIncidentAktualisierenErfolgreichAction(result, x.incidentAktualisierenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostIncidentAktualisierenFehlerAction(error, x.incidentAktualisierenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.IncidentsCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.IncidentsCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.IncidentsCommandService);
        }
        return this.service;
    }
}
